// extracted by css-extract-rspack-plugin
export default {"container":"_808041ac","lazyPlaceholder":"_e7b30026","shimmer":"_c5e1f40e","shimmerLoadingBackground":"_ded167a6","image":"_f9edbc8c"};